import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  return <header className="w-full bg-white py-3 px-6 md:px-12 border-b border-gray-200" data-id="element-219">
      <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-220">
        <div className="flex items-center" data-id="element-221">
          <Link to="/home" className="no-underline" data-id="element-222">
            <img src="https://cdn.magicpatterns.com/uploads/8EVxVy8dkAVEdmFcPkswyr/Caveo_2026_Logo.png" alt="Caveo Logo" className="h-8 md:h-10" data-id="element-223" />
          </Link>
        </div>
        <nav className="hidden md:flex space-x-7" data-id="element-224">
          <Link to="/how-it-works" className="text-[#111111] no-underline hover:text-[#631bb7] transition-colors font-medium text-base" data-id="element-225">
            How It Works
          </Link>
          <Link to="/resources" className="text-[#111111] no-underline hover:text-[#631bb7] transition-colors font-medium text-base" data-id="element-226">
            Resources
          </Link>
          <Link to="/pricing" className="text-[#111111] no-underline hover:text-[#631bb7] transition-colors font-medium text-base" data-id="element-227">
            Pricing
          </Link>
          <Link to="/about-us" className="text-[#111111] no-underline hover:text-[#631bb7] transition-colors font-medium text-base" data-id="element-228">
            About Us
          </Link>
        </nav>
        <div className="hidden md:flex items-center space-x-3" data-id="element-229">
          <a href="/login" className="text-gray-500 no-underline hover:text-[#631bb7] px-3 py-1.5 rounded-lg font-normal text-sm transition-colors" data-id="element-230">
            Login
          </a>
          <Link to="/intro-assessment" className="bg-[#631bb7] text-white px-5 py-2 rounded-lg font-semibold text-base no-underline hover:bg-[#521099] transition-colors shadow-sm" data-id="element-231">
            Get Started
          </Link>
        </div>
        <div className="md:hidden" data-id="element-232">
          <button onClick={toggleMenu} className="text-[#111111] focus:outline-none" data-id="element-233">
            {isMenuOpen ? <XIcon size={24} data-id="element-234" /> : <MenuIcon size={24} data-id="element-235" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {isMenuOpen && <div className="md:hidden fixed inset-0 z-50 bg-white pt-20 px-6" data-id="element-236">
          <div className="flex flex-col space-y-4" data-id="element-237">
            <Link to="/how-it-works" className="text-[#111111] text-xl py-2 no-underline hover:text-[#631bb7] font-medium" onClick={toggleMenu} data-id="element-238">
              How It Works
            </Link>
            <Link to="/resources" className="text-[#111111] text-xl py-2 no-underline hover:text-[#631bb7] font-medium" onClick={toggleMenu} data-id="element-239">
              Resources
            </Link>
            <Link to="/pricing" className="text-[#111111] text-xl py-2 no-underline hover:text-[#631bb7] font-medium" onClick={toggleMenu} data-id="element-240">
              Pricing
            </Link>
            <Link to="/about-us" className="text-[#111111] text-xl py-2 no-underline hover:text-[#631bb7] font-medium" onClick={toggleMenu} data-id="element-241">
              About Us
            </Link>
            <div className="pt-4 flex flex-col space-y-4" data-id="element-242">
              <a href="/login" className="text-[#111111] text-center py-3 border-2 border-gray-200 rounded-lg no-underline hover:border-[#631bb7] hover:text-[#631bb7] font-medium transition-colors" onClick={toggleMenu} data-id="element-243">
                Login
              </a>
              <Link to="/intro-assessment" className="bg-[#631bb7] text-white text-center py-3 rounded-lg font-semibold no-underline hover:bg-[#521099] transition-colors" onClick={toggleMenu} data-id="element-244">
                Get Started
              </Link>
            </div>
          </div>
        </div>}
    </header>;
}